import { Box, Typography, Stack, Rating } from '@mui/material'
import { Image, type ImageData } from '@media-components'
import { getStyles, type CustomStyles } from '@utils/styles'
import defaultStyles, { type StyleClassNames } from './styles'

export type StartRatingData = {
  iconData: ImageData
  title: string
  rating: number
  subtitle: string
}
type StartRatingProps = {
  csx?: CustomStyles<StyleClassNames>
} & Partial<StartRatingData>
export function StartRating({
  title,
  rating,
  subtitle,
  csx,
  iconData,
}: StartRatingProps) {
  const styles = getStyles(defaultStyles, csx)
  return (
    <>
      {iconData && (
        <Box
          {...styles('iconContainer', {
            marginBottom: '4px',
          })}
        >
          <Image {...iconData} {...styles('icon')} />
        </Box>
      )}

      <Stack spacing={0.5} alignItems="center">
        {title && (
          <Typography variant="body1.600" {...styles('title')}>
            {title}
          </Typography>
        )}
        <Box {...styles('ratingContainer')}>
          {rating && <Rating defaultValue={rating} readOnly precision={0.5} />}
          {subtitle && (
            <Typography
              variant="caption1.500"
              color="text.secondary"
              {...styles('description')}
            >
              {`${rating}/5 | ${subtitle}`}
            </Typography>
          )}
        </Box>
      </Stack>
    </>
  )
}
